import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 96 96"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M48.1.3c27.1.2 48.1 22.3 47.7 48.5-.4 26.6-22.3 47.3-48.1 47.1C21.4 95.7-.1 74.2.3 47.5.6 20.7 22.4.3 48.1.3Zm0 5.6C25 5.7 5.9 24.5 5.7 48c-.1 23.3 18.7 42.2 41.8 42.4 23.4.2 42.6-18.6 42.7-42.1.1-23.9-19.3-42.4-42.1-42.4Z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M48 57c10.7.2 19.5 8.3 20.4 19 0 .5.1.9.2 1.4.1 1.6-1 3-2.6 3.1-1.5.1-2.7-1-2.9-2.6-.2-2.1-.4-4.2-1.3-6.2-3.8-8.8-14.6-11.9-22.5-6.3-3.9 2.7-6.1 6.5-6.4 11.3 0 .6-.1 1.2-.2 1.8-.3 1.2-1.6 2-2.8 1.9-1.4-.1-2.5-1.1-2.5-2.6s.1-2.9.4-4.4c1.9-8.2 7-13.4 15.1-15.7 1.7-.3 3.4-.4 5.1-.7ZM41 27.3c0 1.5-1.4 2.3-2.5 1.6-.2-.1-.4-.3-.6-.5L29 19.8c-.8-.8-1-1.6-.5-2.4.6-.9 1.7-1.1 2.5-.3l9.4 9.1c.4.5.5.9.6 1.1ZM67.9 18.4c-.4.6-.6 1.1-.9 1.4-3 3-6 5.9-9.1 8.8-.8.8-1.7.8-2.4.1-.7-.7-.7-1.7.1-2.4 3-3 6.1-5.9 9.1-8.9.6-.5 1.2-.8 1.9-.4.6.3.9.9 1.3 1.4ZM32.3 48.5a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4ZM64.5 48.5a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4Z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "SmileyRate1"}) } }